import { useState, ReactElement } from "react";
import { MdKeyboardArrowDown } from "react-icons/md";

export function LeftSidebar({
    icon,
    title,
    children,
    collapsedWidth = "w-[60px]",
    extendedWidth = "w-[320px]",
    collapsedContent,
}: {
    icon: ReactElement;
    title: string;
    children: ReactElement;
    collapsedWidth?: string;
    extendedWidth?: string;
    collapsedContent?: ReactElement;
}) {
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

    return (
        <div
            className={`bg-base-100 border-r border-base-300 transition-all duration-300 flex flex-col ${
                sidebarCollapsed ? collapsedWidth : extendedWidth
            }`}
        >
            {/* Logo and collapse button */}
            <div className="flex items-center justify-between p-4 border-b border-base-300">
                {!sidebarCollapsed && (
                    <div className="flex items-center">
                        {icon}

                        <span className="font-bold text-lg">{title}</span>
                    </div>
                )}
                <button
                    className="btn btn-ghost btn-sm btn-square"
                    onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                >
                    {sidebarCollapsed ? (
                        <MdKeyboardArrowDown className="h-5 w-5 -rotate-90" />
                    ) : (
                        <MdKeyboardArrowDown className="h-5 w-5" />
                    )}
                </button>
            </div>

            {/* Sidebar content */}
            {!sidebarCollapsed ? (
                <div className="h-full p-3">{children}</div>
            ) : (
                collapsedContent
            )}
        </div>
    );
}
